import React from "react";
import { Typography, Stack, Box } from "@mui/material";
import SkillItemRow from "./SkillItemRow";
import { JOB_COLOR } from "../../../constants/colors";
import InnerFrame from "../../shared/InnerFrame";

/**
 * スキルカテゴリ表示コンポーネント
 * - 言語ごとに Paper（カード）でまとめる
 */
const SkillCategory = ({ category, owner }) => {
  // categoryがない時は表示しない
  if (!category?.skillGroups || category.skillGroups.length === 0) {
    return null;
  }

  return (
    <Box>
      {/* カテゴリ名（フロントエンド / バックエンド） */}
      <Typography fontWeight="bold" sx={{ color: JOB_COLOR }}>
        {category.categoryLabel}
      </Typography>

      {/* 言語ごとのカード一覧 */}
      <Stack spacing={2}>
        {category.skillGroups.map((group) => (
          <InnerFrame key={group.groupId}>
            {/* 言語1行分の表示（言語名 / 経験月数 / ランク / FW一覧） */}
            <SkillItemRow
              parentSkill={group.parentSkill}
              childSkills={group.childSkills}
              owner={owner}
              categoryKey={category.categoryKey}
            />
          </InnerFrame>
        ))}
      </Stack>
    </Box>
  );
};

export default SkillCategory;
